import { HttpBackend, HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IEnvironment } from "@ramudden/models/environment";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class ConfigurationService {
    private httpClient: HttpClient;

    public configuration: IEnvironment;

    constructor(handler: HttpBackend) {
        // avoid interceptors
        this.httpClient = new HttpClient(handler);
    }

    public async loadConfiguration(environment): Promise<void> {
        this.configuration = await firstValueFrom(this.httpClient.get<IEnvironment>(environment.configUrl));
    }

    get isLocal(): boolean {
        return this.configuration && this.configuration.title === "Local";
    }
}
